import { readonly, ref } from 'vue';

/**
 * The region-qualified locale the current reader formats numbers and dates with. The
 * fallback is region-qualified on purpose: a bare `en` is US-shaped, which is what
 * we are trying to avoid, `en` renders 1/31/26 where `en-GB` renders 31/01/2026.
 */
export const FALLBACK_LOCALE = 'en-GB';

const locale = ref(FALLBACK_LOCALE);

/**
 * Point every reader at a new locale. Called from the Inertia navigate listener.
 */
export function setLocale(next) {
    if (next) {
        locale.value = next;
    }
}

/**
 * The locale as a plain string, for callers outside a setup context.
 */
export function currentLocale() {
    return locale.value;
}

/**
 * ICU locales reach the frontend underscored on model props — `vendor.locale` is
 * `da_DK` — while `Intl` only accepts the hyphenated BCP 47 form. Mirrors the
 * backend's `Locale::bcp47()`, and leaves an already-hyphenated tag alone.
 */
export function toBcp47(value) {
    return value ? String(value).replace('_', '-') : FALLBACK_LOCALE;
}

/**
 * The locale as a readonly ref, for components that should re-render when it changes.
 */
export function useLocale() {
    return readonly(locale);
}
